module.exports = __webpack_public_path__ + "static/media/start-btne104c4708956ebc65b82bfe11b03df3f.webp";